import DailyBulletinPresentation from 'components/organisms/presentations/DailyBulletinPresentation';

const DailyBulletin = () => <DailyBulletinPresentation />;

export default DailyBulletin;
